/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Origin_CreatedInputs */

const en_origin_created = /** @type {(inputs: Origin_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origin created`)
};

const es_origin_created = /** @type {(inputs: Origin_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origen creado`)
};

/**
* | output |
* | --- |
* | "Origin created" |
*
* @param {Origin_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const origin_created = /** @type {((inputs?: Origin_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Origin_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_origin_created(inputs)
	return es_origin_created(inputs)
});